import React, { useState } from 'react';
import '../styles/ApplicationSelectionModal.css';
import thermaxLogo from "../assets/Thermax-Logo.wine01.png";

function ApplicationSelectionModal({ applications, onSelect, loading, error }) {
  const [selectedAppId, setSelectedAppId] = useState('');

  return (
    <div className="app-select-overlay">
      <div className="app-select-modal">
        <img src={thermaxLogo} alt="Thermax" className="app-select-logo" />
        <h2>Select Your Application</h2>
        <p>We couldn't find an application linked to your account yet. Choose the one you belong to.</p>

        <select
          className="app-select-dropdown"
          value={selectedAppId}
          onChange={(e) => setSelectedAppId(e.target.value)}
        >
          <option value="" disabled>Choose an application…</option>
          {applications.map((app) => (
            <option key={app.id} value={app.id}>{app.name}</option>
          ))}
        </select>

        {error && <div className="app-select-error">{error}</div>}

        <button
          className="app-select-confirm-btn"
          disabled={!selectedAppId || loading}
          onClick={() => onSelect(selectedAppId)}
        >
          {loading ? 'Saving…' : 'Continue'}
        </button>
      </div>
    </div>
  );
}

export default ApplicationSelectionModal;
